<micro-select-combo #sel
              placeholder="HTTP Scheme"
              [mode]="mode"
              [(id)]="scheme"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched">
</micro-select-combo>
